type HideIconProps = {
  className?: string;
};

const HideIcon: React.FC<HideIconProps> = ({ className = '' }) => (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11 3.97505C14.79 3.97505 18.17 6.10505 19.82 9.47505C19.23 10.695 18.4 11.745 17.41 12.595L18.82 14.005C20.21 12.775 21.31 11.235 22 9.47505C20.27 5.08505 16 1.97505 11 1.97505C9.73 1.97505 8.51 2.17505 7.36 2.54505L9.01 4.19505C9.66 4.06505 10.32 3.97505 11 3.97505ZM9.93 5.11505L12 7.18505C12.57 7.43505 13.03 7.89505 13.28 8.46505L15.35 10.535C15.43 10.195 15.49 9.83505 15.49 9.46505C15.5 6.98505 13.48 4.97505 11 4.97505C10.63 4.97505 10.28 5.02505 9.93 5.11505ZM1.01 1.84505L3.69 4.52505C2.06 5.80505 0.77 7.50505 0 9.47505C1.73 13.865 6 16.975 11 16.975C12.52 16.975 13.98 16.685 15.32 16.155L18.74 19.575L20.15 18.165L2.42 0.425049L1.01 1.84505ZM8.51 9.34505L11.12 11.955C11.08 11.965 11.04 11.975 11 11.975C9.62 11.975 8.5 10.855 8.5 9.47505C8.5 9.42505 8.51 9.39505 8.51 9.34505ZM5.11 5.94505L6.86 7.69505C6.63 8.24505 6.5 8.84505 6.5 9.47505C6.5 11.955 8.52 13.975 11 13.975C11.63 13.975 12.23 13.845 12.77 13.615L13.75 14.595C12.87 14.835 11.95 14.975 11 14.975C7.21 14.975 3.83 12.845 2.18 9.47505C2.88 8.04505 3.9 6.86505 5.11 5.94505Z"
        fill="#202020"
      />
    </svg>
  );

export default HideIcon;
